import { render, staticRenderFns } from "./cModalRegCoti.vue?vue&type=template&id=a00e96c4&scoped=true"
import script from "./cModalRegCoti.vue?vue&type=script&lang=js"
export * from "./cModalRegCoti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00e96c4",
  null
  
)

export default component.exports